import { color } from '@core-ds/primitives';

export default color;
